module.exports = {
  LEDIG: { api: 'LEDIG', human: 'ledig' },
  VERHEIRATET: { api: 'VERHEIRATET', human: 'verheiratet' },
  VERWITWET: { api: 'VERWITWET', human: 'verwitwet' },
  GESCHIEDEN: { api: 'GESCHIEDEN', human: 'geschieden' },
  EINGLEBENPARTNER: { api: 'EINGLEBENPARTNER', human: 'eingetragene Lebenspartnerschaft' },
  EINGLEBENPARTNERTOT: { api: 'EINGLEBENPARTNERTOT', human: 'eingetragene Lebenspartnerin/eingetragener Lebenspartner verstorben' },
  EINGLEBENPARTNERAUFG: { api: 'EINGLEBENPARTNERAUFG', human: 'eingetragene Lebenspartnerschaft aufgehoben' }
}
